import React from 'react';
import {Switch} from '@headlessui/react'
import {clsx} from "clsx";

function Toggle({children, get, set, disabled}) {
	
	return (
		<Switch.Group as="div" className="flex items-center">
			<Switch
				checked={get}
				onChange={() => !disabled && set(!get)}
				className={clsx(
					get ? 'bg-gradient-to-br from-[#0b5f82] to-[#0b9cbc]' : 'bg-gray-200',
					'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-all duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-[#0b9cbc]/10 focus:ring-offset-0',
					disabled && 'opacity-50 cursor-not-allowed grayscale'
				)}
			>
        <span
	        aria-hidden="true"
	        className={clsx(
		        get ? 'ltr:translate-x-5 rtl:-translate-x-5' : 'translate-x-0',
		        'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition duration-300 ease-in-out'
	        )}
        />
			</Switch>
			<Switch.Label as="span" className="ltr:ml-4 rtl:mr-4 text-sm select-none cursor-pointer">
				<span className="font-bold text-gray-700 hover:text-gray-900 transition-colors">{children}</span>
			</Switch.Label>
		</Switch.Group>
	)
}

export default Toggle;